import { render, staticRenderFns } from "./AscPowerBiDashboardWrapper.vue?vue&type=template&id=092018bd&"
import script from "./AscPowerBiDashboardWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPowerBiDashboardWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPowerBiDashboardWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports